import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card, Button, Input, Label } from 'reactstrap';

import Download from '../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Download.svg'
import LoadingOverlay from 'react-loading-overlay';
import Loader from "react-loaders";
import CustomModal from '../../../../../../../Components/Modals/CustomModal';
import { Editor, SetInnerHtmlWithClassReplacement } from '../../../../../../../../Utils/Constants';
import ReactQuill from 'react-quill';
import AnnotationCanvas, {PhotoDisplay} from '../AssetAnnotations/AnnotationCanvas'
import AnnotationIcon from '../../../../../../../../designUtils/ProjectDashboard/AnnotationIcon.svg'

import {INIT_IMAGES,
  CURRENT_USER,
  uuid,
  TOOLS,
  COLORS,} from '../AssetAnnotations/HardCodeImageData';
import SubmissionAssetSatusChangeService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/SubmissionAssetSatusChangeService';
import SaveSubmissionsAssetsAnnonationService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/SaveSubmissionsAssetsAnnonationService';
import AddSubmissionsChatService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/AddSubmissionsChatService';
import FetchSubmissionsChatsService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchSubmissionsChatsService';

// Comments Component
function CommentsDetailsComp(props) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [expandedNote, setExpandedNote] = useState(null);

  const handleQuillChange = (value, delta, source, editor) => {
    const plainText = editor.getText().trim();
    props.setComment(plainText === '' ? '' : value);
  };

  const openNoteModal = (fullMessage) => {
    setExpandedNote(fullMessage);
    setIsExpanded(true);
  };

  const ReadMore = ({ htmlContent = '', maxLength, onReadMoreClick }) => {
    const isLong = htmlContent.length > maxLength;
    const truncatedContent = isLong ? htmlContent.substring(0, maxLength) + '...' : htmlContent;

    return (
      <div>
        <span
          className="issue-description-set d-flex flex-wrap"
          dangerouslySetInnerHTML={{ __html: truncatedContent }}
        />
        {isLong && (
          <span
            style={{ fontSize: '13px' }}
            className="cursor-pointer d-flex justify-content-end text-primary"
            onClick={() => onReadMoreClick(htmlContent)}
          >
            ....Read More
          </span>
        )}
      </div>
    );
  };

  return (
    <>
    
           
      <div className="p-3">
      <LoadingOverlay
            active={props.loadScreen}
              styles={{
                overlay: (base) => ({
                  ...base,
                  background: "#f1f4f6",
                  opacity: 1,
                }),
                content: (base) => ({
                  ...base,
                  color: "#000",
                }),
              }}
              spinner={<Loader active type="ball-pulse" />}
              text="Loading chat details..."
            >
             
        <div className="comment-input-container mt-2">
          <ReactQuill
            theme={'snow'}
            modules={Editor.modules}
            formats={Editor.formats}
            value={props.comment}
            onChange={handleQuillChange}
            bounds={'.quill-prod'}
            placeholder='Add Your Comments Here'
          />
        </div>
        <div className="p-3 w-100 d-flex justify-content-end">
          <Button
            className="btn-background-color"
            disabled={!props.comment}
            onClick={() => props.addSubmissionsChats()}
          >
            Add Note
          </Button>
        </div>
        
        <div className="comment-card rounded border">
          {(props.noteList || []).length > 0 ? (
            props.noteList.map((noteItem, index) => (
              <div key={index}>
                <div
                  className={`d-flex p-2 ${
                    noteItem.loggedInUser === 1 ? "justify-content-end" : "justify-content-start align-items-end"
                  }`}
                >
                  <div className="d-flex align-items-start">
                    {props.selectedImage && props.selectedImage.loggedInUser !== noteItem.submittedBy ?
                      <div className="p-1 user-short-name">{noteItem.userShortName && noteItem.userShortName.toUpperCase()}</div> : ''}
                    <p
                      className={`p-2 mb-0 ${
                        noteItem.loggedInUser === 1 ? "chat-background-color-sent" : "chat-background-color"
                      }`}
                    >
                      <ReadMore htmlContent={noteItem.notes} maxLength={200} onReadMoreClick={openNoteModal}/>
                      <span className="float-right pt-1">{noteItem.submittedOn}</span>
                    </p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-muted px-2 mt-3 ml-2">No Comments</p>
          )}
        </div>
        </LoadingOverlay>
      </div>
      <CustomModal
        header={"Comment"}
        isOpen={isExpanded}
        toggle={() => setIsExpanded(!isExpanded)}
        size={"xl"}
        className="curve-popup"
      >
        <p style={{ fontSize: "19px" }} className="issue-discription-set" dangerouslySetInnerHTML={{ __html: expandedNote || '' }} />
      </CustomModal>
    </>
  );
}

const ProjectDeliveriesGraphicsDetails = (props) => {
  const {
    selectedImage = null,
    setSelectedImage = () => {},
    setSelectedStatus = () => {},
    loggedInUser,
    file = [],
  } = props;
  const [noteList, setNoteList] = useState([]);
  const [downloadAction, setDownloadAction] = useState(false);
  const [selectedTool, setSelectedTool] = useState('circle');
  const [selectedColor, setSelectedColor] = useState('#ff4444');
  const [annotationsPopup, setAnnotationsPopup] = useState(false);
  const [stagedAnnotations, setStagedAnnotations] = useState([]);
  const [isCloseConfirmOpen, setIsCloseConfirmOpen] = useState(false);
  const [comment, setComment] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [originalAnnotations, setOriginalAnnotations] = useState([]);
  const [loadScreen,setLoadScreen]=useState(false)

  // Auto-select first image when file list changes
useEffect(() => {
  if (file && file.length > 0) {
    // Check if selected image exists in current filtered list
    const isSelectedImageInList = selectedImage 
      ? file.some(f => f.assetId === selectedImage.assetId)
      : false;
    
    // Only auto-select if:
    // 1. No image is selected, OR
    // 2. Selected image is not in the current filtered list, OR
    // 3. Submission changed
    if (!selectedImage || !isSelectedImageInList) {
      const firstFile = file[0];
      handleImageClick(firstFile);
    }
  } else {
    // No files in filtered list
    setSelectedImage(null);
    setNoteList([]);
  }
}, [file, props.submissionData.id]); // Add file as dependency
  const submissionsChats = (file) => {
    let data = {
      assetId: file.assetId
    }
    setLoadScreen(true);
    FetchSubmissionsChatsService(props.token, data).then((res) => {
      setNoteList(res);
      setLoadScreen(false);
    })
};

  const addSubmissionsChats = () => {
    const data = {
      notes: comment,
      assetId: selectedImage.assetId,
    };
    AddSubmissionsChatService(props.token, data).then((res) => {
      if (res) {
        console.log(res);
        setNoteList(res.noteList);
        setComment('');
      }
    });
  };
  const handleImageClick = (file) => {
    console.log(file);
    if (typeof setSelectedImage === 'function') {
      setSelectedImage(file);
    }
    if (typeof setSelectedStatus === 'function') {
      setSelectedStatus(file.status || 'new');
    }
    submissionsChats(file)
  };
  const handleDownloadImage = async (url) => {
    setDownloadAction(true);
    try {
      const response = await fetch(url, {
        method: 'GET',
        referrerPolicy: 'no-referrer',
        cache: 'no-store',
      });
      if (!response.ok) throw new Error(`Failed to fetch: ${url}`);

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const downloadLink = document.createElement('a');
      downloadLink.href = blobUrl;
      downloadLink.download = selectedImage.assetName || 'downloaded_file';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Failed to download file:', error);
    } finally {
      setDownloadAction(false);
    }
  };

  const handleSubmissionAssetSatusChange = (status) => {
    let data = {
      status: status,
      assetId: selectedImage.assetId,
      notes:'',
      submissionAssetId: props.submissionData && props.submissionData.id,
      submissionFor: '',
      projectId: props.selectedProjectData && props.selectedProjectData.projectId,
    }

    SubmissionAssetSatusChangeService(props.token, data).then((res) => {
      if (res) {
        console.log(res);
        props.setAllAssetsList(res.assetetsDetails.assetList)
        const filterDoc = res.assetetsDetails.assetList && res.assetetsDetails.assetList.filter((assets) => assets.assetSubCategory == 5) || [];
        const filterGraphics = res.assetetsDetails.assetList && res.assetetsDetails.assetList.filter((assets) => assets.assetSubCategory == 7) || [];
        props.setGraphicsStatusCount(res.assetetsDetails && res.assetetsDetails.graphicsStatusCount);
        props.setDocumentStatusCount(res.assetetsDetails && res.assetetsDetails.documentStatusCount);
        
        if (props.action == true) {
          props.setAssetList(filterGraphics);
          const selected=filterGraphics &&filterGraphics.filter((aset)=>aset.assetId==selectedImage.assetId)||[]
          setSelectedImage(selected[0])}
          else {
            props.setAssetList(filterDoc);
          }
            props.setSubmissionList(res.submissionDetails.submissionList);
      }
    })
  }

  const handleAnnotaionPopup = () => {
    const cleanAnnotations = (selectedImage.annotations || []).map(({ isNew, isEdited, ...ann }) => ann);
    setOriginalAnnotations(cleanAnnotations);
    setStagedAnnotations(cleanAnnotations);
    setAnnotationsPopup(true);
  };

  const handleStageAnnotation = (coords, type, color, comment) => {
    const newAnnotationObject = {
      id: uuid(),
      type,
      color,
      coordinates: coords,
      comment,
      userName: loggedInUser,
      createdAt: new Date().toISOString(),
      isNew: true
    };
    setStagedAnnotations(prev => [...prev, newAnnotationObject]);
  };

  const handleStageEdit = (annotationId, newComment) => {
    if (!newComment || newComment.trim() === '') {
      return;
    }
    setStagedAnnotations(prev =>
      prev.map(ann => {
        if (ann.id === annotationId) {
          if (ann.comment === newComment) {
            return ann;
          }
          return { ...ann, comment: newComment, isEdited: true };
        }
        return ann;
      })
    );
  };

  const handleStageDelete = (annotationId) => {
    setStagedAnnotations(prev => prev.filter(ann => ann.id !== annotationId));
  };

  const hasUnsavedChanges = JSON.stringify(originalAnnotations) !== JSON.stringify(stagedAnnotations);

  const handleSaveAllAnnotations = () => {
  if (!hasUnsavedChanges || isSaving) {
    return;
  }
  setIsSaving(true);

  const annotationsToSave = stagedAnnotations.map(({ isNew, isEdited, ...ann }) => ({
    ...ann,
    id: ann.id || uuid(),
    createdAt: ann.createdAt || new Date().toISOString(),
    userName: ann.userName || (props.loggedInUser || 'system')
  }));

  let data = {
    submissionFor: '',
    submissionAssetId: selectedImage.submissionId,
    assetId: selectedImage.assetId,
    submissionId: selectedImage.submissionDetailId,
    projectId: props.selectedProjectData && props.selectedProjectData.projectId,
    annotations: annotationsToSave
  };

  SaveSubmissionsAssetsAnnonationService(props.token, data)
    .then((res) => {
      if (res && res.assetList && res.assetList.assetList) {
        console.log(res.assetList)
        // Update the parent's asset list
        const updatedAssets =res.assetList.assetList&& res.assetList.assetList.filter((ass)=>ass.assetSubCategory ===7);
        props.setAssetList(updatedAssets);
        props.setGraphicsStatusCount(res.assetList && res.assetList.graphicsStatusCount);
        
        // Find and update the current image with the latest data
        const updatedImage = updatedAssets.find(
          file => file.assetId === selectedImage.assetId
        );

        
        if (updatedImage) {
          // Update the selected image in the parent component's state
          props.setAllAssetsList(prevAssets => {
            return prevAssets.map(asset => 
              asset.assetId === updatedImage.assetId ? updatedImage : asset
            );
          });
          
          // Update local state
          setSelectedImage(updatedImage);
        }
      }
      setAnnotationsPopup(false);
    })
    
    .finally(() => {
      setIsSaving(false);
    });
};

  const handleCloseAnnotationPopup = () => {
    if (hasUnsavedChanges) {
      setIsCloseConfirmOpen(true);
    } else {
      setAnnotationsPopup(false);
    }
  };

  const handleDiscardAndClose = () => {
    setIsCloseConfirmOpen(false);
    setAnnotationsPopup(false);
  };

  const handleSaveAndClose = () => {
    handleSaveAllAnnotations();
    setIsCloseConfirmOpen(false);
  };

  const handleDeleteAndSaveAnnotation = (annotationId) => {
    const updatedAnnotations = stagedAnnotations.filter(ann => ann.id !== annotationId);

    setStagedAnnotations(updatedAnnotations);
    setOriginalAnnotations(updatedAnnotations);

    if (typeof setSelectedImage === 'function') {
      setSelectedImage({
        ...selectedImage,
        annotations: updatedAnnotations,
      });
    }

    const annotationsToSave = updatedAnnotations.map(({ isNew, isEdited, ...ann }) => ann);

    let data = {
      submissionFor: '',
      submissionAssetId: selectedImage.submissionId,
      assetId: selectedImage.assetId,
      submissionId: selectedImage.submissionDetailId,
      projectId: props.selectedProjectData && props.selectedProjectData.projectId,
      annotations: annotationsToSave
    };
    

    SaveSubmissionsAssetsAnnonationService(props.token, data).then((res) => {
      if (res) {
        console.log("Background delete successful:", res);
        const updatedAssets =res.assetList.assetList&& res.assetList.assetList.filter((ass)=>ass.assetSubCategory ===7);
       props.setAssetList(updatedAssets);
        props.setSubmissionList && props.setSubmissionList(res.submissionDetails.submissionList);

        const updatedImage = updatedAssets.find(
          file => file.assetId === selectedImage.assetId
        );

        
        if (updatedImage) {
          // Update the selected image in the parent component's state
          props.setAllAssetsList(prevAssets => {
            return prevAssets.map(asset => 
              asset.assetId === updatedImage.assetId ? updatedImage : asset
            );
          })}

        // const updatedImage = updatedAssets.find(file => file.assetId === selectedImage.assetId);
        // if (updatedImage && typeof setSelectedImage === 'function') {
        //   setSelectedImage(updatedImage);
        // }
      }
    }).catch(error => {
      console.error("Failed to delete and save annotation in background:", error);
    });
  };
  return (
    <>
      <Row className='ml-2 mt-2'>
        {/* Vertical Scroll Column */}
        <Col md={2} className="vertical-scroll-column">
            {file && file.map((fileItem, index) => {
              const isSelected = fileItem === selectedImage;
              return (
                <Card
                  key={index}
                  className={`mb-3 p-2 text-center grahics-qa-image-card vertical-scroll-blur mt-3 ${
                    isSelected ? 'qa-selected-blur' : ''
                  }`}
                  onClick={() => handleImageClick(fileItem)}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    src={fileItem.filePath}
                    alt={fileItem.actualFileName}
                    className="grahics-qa-asset-img-vertical-scroll graphics-qa-container"
                  />
                  <div className="d-flex justify-content-between">
                    <span className="ml-1">
                      <b style={{ color: '#B01A00' }}>#{fileItem.amazonPosition}</b>
                    </span>
                    <div style={{ paddingRight: '60px' }}>
                      <b>{fileItem.assetId}</b>
                    </div>
                  </div>
                </Card>
              );
            })}
    
        </Col>

        {/* Main Content Column */}
        <Col md={10}>
          <Card className="mt-2" style={{ position: 'relative' }}>
            <Row>
              {/* Image Display Column */}
              <Col md={6}>
                {selectedImage && (
                  <Card className="mb-3 p-3 ml-3 qa-selected-image">
                    <div
                      className={`grahics-qa-status-dot-selected ${selectedImage.statusText || ''}`}
                      style={{ backgroundColor: selectedImage.statusColor, cursor: 'pointer' }}
                      title={
                        selectedImage.statusText === "Sent for Approval"
                          ? "Need Approval"
                          : selectedImage.statusText || ""
                      }
                    ></div>
                    
                    <PhotoDisplay
                      image={selectedImage}
                      annotations={selectedImage && selectedImage.annotations || []}
                    />
                    
                    <div className="graphics-qa-id d-flex align-items-center justify-content-between mt-1">
                      <div className="d-flex align-items-center">
                        <span className="mr-3">
                          <b>{selectedImage.assetId}</b>
                        </span>
                        <span className="ml-2 comment-paragraph-task-storename">
                          <b>{selectedImage.assetName}</b>
                        </span>
                      </div>
                      <span className="text-danger">
                        #{selectedImage.amazonPosition || ''}
                      </span>
                      <div className="d-flex align-items-center">
                        {props.flag && props.flag && selectedImage.status != 5 ?
                          <button
                            title="Add Annotations"
                            className="info-button-background-none ml-2"
                            onClick={handleAnnotaionPopup}
                          >
                            <img src={AnnotationIcon} alt="Annotation" />
                          </button> : ''}
                        <button
                          onClick={() => handleDownloadImage(selectedImage.filePath, "DownloadeImage")}
                          className='info-button-background-none'
                          title='Download'
                        >
                          <img
                            className={`p-1 ${downloadAction === "DownloadeImage" ? 'button-img-background-download-inprogress' : 'button-img-background-download'}`}
                            src={Download}
                            alt='Download'
                          />
                        </button>
                        {downloadAction === "DownloadeImage" && <span className="ml-1">Downloading</span>}
                      </div>
                    </div>
                    
                    <div className="d-flex justify-content-between mt-1">
                      <h6 className="d-flex justify-content-between">
                        <p className='mb-1'>{selectedImage.fileSize}</p>
                      </h6>
                      <p className='mb-1'>
                        Last Modified on &nbsp; <b> {selectedImage.updatedAt} </b>
                      </p>
                    </div>
                    
                   <div className='d-flex justify-content-between mt-1'>
                    <p className='mb-1'>
                      Destination Category : <b> {selectedImage.destinationSubCategories} </b>
                    </p>
                    
                    <span className='d-flex justify-content-end '>
                      {(props.projectPermissions && props.projectPermissions.ProjectAssetsDeliveries_ApprovedbyClient 
                      && selectedImage.status != 5 &&
                      selectedImage.status != 12
                      && selectedImage.status != 15
                      && selectedImage.status != 16) &&

                        <Button
                          onClick={() => handleSubmissionAssetSatusChange(5)}
                          className="btn-send-approval mb-1">
                          Approve
                        </Button>}
                    </span>
                    </div>
                    <div><p className='mb-1'>
                Asin List : <b> {selectedImage.asinList} </b>
                </p></div>
                  </Card>
                )}
              </Col>

              {/* Comments Column */}
              <Col md={6}>
                {selectedImage && (
                  <CommentsDetailsComp
                  loadScreen={loadScreen}
                    setComment={setComment}
                    selectedImage={selectedImage}
                    comment={comment}
                    noteList={noteList}
                    addSubmissionsChats={addSubmissionsChats}
                  />
                )}
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      {/* Annotation Modal */}
      <CustomModal
        isOpen={annotationsPopup}
        toggle={handleCloseAnnotationPopup}
        size={"xl"}
        header={<p title={selectedImage && selectedImage.assetName} className="comment-paragraph-Project-asin-title">{props.selectedImage && props.selectedImage.assetName}</p>}
       className='my-task-custom-module'
      >
        <Card>
        <div className="annotation-tools">
              <div className="tool-group">
                <span className="tool-label">Tools:</span>
                <div className="tool-options">
                  {TOOLS.map(tool => (
                    <button
                      key={tool.type}
                      className={`tool-btn ${selectedTool === tool.type ? 'active' : ''}`}
                      onClick={() => setSelectedTool(tool.type)}
                    >
                      {tool.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="color-group">
                <span className="color-label">Colors:</span>
                <div className="color-options">
                   {COLORS.map(color => (
                    <button
                      key={color}
                      className={`color-swatch ${selectedColor === color ? 'active' : ''}`}
                      style={{backgroundColor: color}}
                      onClick={() => setSelectedColor(color)}
                    />
                  ))}
                </div>
              </div>
              <Button
                className='btn-background-color ml-auto'
                onClick={handleSaveAllAnnotations}
                disabled={!hasUnsavedChanges || isSaving}
              >
                {isSaving ? 'Saving...' : 'Save All Changes'}
              </Button>
           </div>
         <AnnotationCanvas
              image={selectedImage}
              selectedTool={selectedTool}
              selectedColor={selectedColor}
              onStageAnnotation={handleStageAnnotation}
              annotations={stagedAnnotations}
              onEditAnnotation={handleStageEdit}
              onDeleteAnnotation={handleStageDelete}
              onDeleteAndSave={handleDeleteAndSaveAnnotation}
            />
        </Card>
      </CustomModal>

      {/* Confirmation Modal */}
      <CustomModal
        isOpen={isCloseConfirmOpen}
        toggle={() => setIsCloseConfirmOpen(false)}
        size={"md"}
        className="curve-popup"
        header={"Unsaved Changes"}
      >
        <Card className="curve-popup p-3 ">
          <Row>
            <Col md={12}>
              <div>
                <h6>Do you want to save changes before proceeding?</h6>
              </div>
              <div className='mb-2 mt-4 d-flex justify-content-end'>
                <Button
                  className=" no-btn-background-color mr-2"
                  onClick={handleDiscardAndClose}
                >
                  No
                </Button>
                <Button
                  className='btn-background-color'
                  onClick={handleSaveAndClose}
                >
                  Save
                </Button>
              </div>
            </Col>
          </Row>
        </Card>
      </CustomModal>
    </>
  );
};

const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
  storeOverview: state.accountOverview.store.storeOverview,
  UserPermission: state.accountOverview.store.StoreUserPermission,
  accessLevel: state.loggedUser.accessLevel,
});

export default connect(mapStateToProps)(ProjectDeliveriesGraphicsDetails);
